var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    初始化数据库\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }